<span>
<a (click)="click()">{{linkText}}</a>
</span>
